import IconTextButton from './IconTextButton.vue';

export default IconTextButton;
